import React from "react";
import FormField from "../../../FormField";
import useProjectStore from '../../../../store-zustand/project';

const AnnotationName = ({ name, type, onChange }) => {
  const { setcurrentAnnotationName, currentAnnotationName } = useProjectStore();
  
  const handleName = (e) => {
    setcurrentAnnotationName(e.target.value)
    if (onChange) onChange(e.target.value);
  };

  return (
    <FormField label={`${type} Name`}>
      <input type="text" placeholder={`Enter ${type} Name`} value={currentAnnotationName} onChange={handleName} />
    </FormField>
  );
};

export default AnnotationName;